interface RedactTextProps {
  color: string;
  size: string;
  text: string;
}

function RedactText({ color, size, text }: RedactTextProps) {
  return <text className={`${color} ${size} whitespace-pre-line`}>{text}</text>;
}

export default RedactText;
